import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";

const fetch = (): AxiosPromise<CalendarApi> => {
  return api.get<CalendarApi>(endpoints.CALENDAR.GET());
};

export const calendarApi = {
  fetch,
};

export interface CalendarApi {
  events: CalendarEventApi[];
}

export interface CalendarEventApi {
  start: Date;
  end: Date;
  courseName: string;
  courseId: number;
  topicName: string;
  isOnline: boolean;
}
